import Vue from "vue"
import VueRouter from "vue-router";
import index from "@/views/index/index.vue";
import contact from "@/views/service/contact.vue";
import dock from "@/views/service/dock.vue";
import incubation from "@/views/service/incubation.vue";
import analysis from "@/views/service/analysis.vue";
import parlor from "@/views/parlor/parlor.vue";
import parlorDetail from "@/views/parlor/detail.vue";
import digitize from "@/views/service/digitize.vue";
import news from "@/views/news/news.vue";
import newsDetail from "@/views/news/detail.vue";
import policy from "@/views/policy/policy.vue";
import policyDetail from "@/views/policy/detail.vue";

Vue.use(VueRouter)
const routes = [
  {
    path: "/",
	redirect: "/home",
  },
  {
    path: "/home",
    component: index,
    meta: {headMenu:true }
  },
  {
    path: "/contact",
    component: contact,
    meta: {headMenu:true }
  },
  {
    path: "/dock",
    component: dock,
    meta: {headMenu:true }
  },
  {
    path: "/incubation",
    component: incubation,
    meta: {headMenu:true }
  },
  {
    path: "/analysis",
    component: analysis,
    meta: {headMenu:true }
  },
  {
    path: "/parlor",
    component: parlor,
    meta: {headMenu:true }
  },
  {
    path: "/parlor/detail/:id",
    component: parlorDetail,
    name: "parlorDetail",
    meta: {headMenu:true }
  },
  {
    path: "/digitize",
    component: digitize,
    meta: {headMenu:true }
  },
  {
    path: "/news",
    component: news,
    meta: {headMenu:true }
  },
  {
    path: "/news/detail/:id",
    component: newsDetail,
    name: "newsDetail",
    meta: {headMenu:true }
  },
  {
    path: "/policy",
    component: policy,
    meta: {headMenu:true }
  },
  {
    path: "/policy/detail/:id",
    component: policyDetail,
    name: "policyDetail",
    meta: {headMenu:true }
  },
]

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch((err) => err)
}

const router = new VueRouter({
  mode:'history', //本地测试环境、在线测试环境
  // mode: "hash", //正式环境
  // base:"/pc-all/", //正式环境
  routes,
  scrollBehavior(){
    return{x:0,y:0}
  }
})

export default router
